import { Factory, trait } from 'miragejs';

export default Factory.extend({
  enabled: false,
  camera: 'back',
  rescanAfter: 'months',
  rescanAfterValue: 12,
  imagesVisible: false,
  withFlowAssign: trait({
    afterCreate(idScanPage, server) {
      const flow = server.schema.flows.findBy({ idScanPageId: null });

      flow?.update({
        idScanPage: idScanPage,
      });
    },
  }),
});
